import React from 'react';
import { ErrorDataIcon } from '@/components/icons';

interface ErrorViewProps {
  className?: string;
  onRetry?: () => void;
}

export const ErrorView: React.FC<ErrorViewProps> = ({
  className = "",
  onRetry,
}) => {
  const errorIcon = <ErrorDataIcon className="w-6 h-6 text-red-600" />;

  return (
    <div className={`flex flex-col items-center justify-center py-8 px-4 ${className}`}>
      <div className="p-2">
        {errorIcon}
      </div>
      <h3 className="text-gray-800 text-center text-lg font-semibold mb-2" style={{ fontFamily: "Roboto, sans-serif" }}>
        Unable to load data
      </h3>
      <p className="text-gray-500 text-center text-sm" style={{ fontFamily: "Roboto, sans-serif" }}>
        Something went wrong while loading this widget.
      </p>
      <p className="text-gray-500 text-center text-sm" style={{ fontFamily: "Roboto, sans-serif" }}>
        Please try again.
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-1.5 text-sm font-medium text-white bg-[#449995] rounded-lg hover:bg-[#357d79] transition-colors"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          Retry
        </button>
      )}
    </div>
  );
};
